/**
 * task-progress.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input } from "@angular/core";
import { ToolboxActivity } from "app/aggregation/toolbox-activity";

@Component({
    selector: "task-progress",
    template: `
<h3>Progress</h3>
<div class="progress">
    <div
        *ngIf="task.isScheduled"
        class="progress-bar progress-bar-striped active"
        style="width: 100%">
        <span>evaluating...</span>
    </div>
    <div
        *ngIf="task.isComplete && task.population === 0"
        class="progress-bar progress-bar-disabled"
        style="width: 100%">
        <span>The group-algorithm pair you selected had no records.</span>
    </div>

    <div
        class="progress-bar progress-bar-danger"
        [style.width]="100*task.unanswered/task.population + '%'"
        title="Records where one of the target variables was unanswered or empty.">
        <span *ngIf="task.unanswered > 0">{{task.unanswered | thou}} unanswered</span>
    </div>
    <div
        class="progress-bar progress-bar-warning"
        [style.width]="100*task.rejected/task.population + '%'"
        title="Records that were rejected by the provided filter(s).">
        <span *ngIf="task.rejected > 0">{{task.rejected | thou}} rejected</span>
    </div>
    <div
        class="progress-bar progress-bar-success"
        [style.width]="100*task.processed/task.population + '%'"
        title="Records that the analysis tool has evaluated.">
        <span *ngIf="task.processed > 0">{{task.processed | thou}} processed</span>
    </div>
    <div
        class="progress-bar progress-bar-info"
        [style.width]="100*task.unknownCount/task.population + '%'"
        title="Records that the results do not account for.">
        <span *ngIf="task.unknownCount > 0">{{task.unknownCount | thou}} unknown</span>
    </div>


    <div
        class="progress-bar progress-bar-striped active"
        [style.width]="100*task.remaining/task.population + '%'"
        title="Records that the tool has not yet reached.">
        <span *ngIf="task.remaining > 0">
            {{task.populationIsEstimated ? "???" : (task.remaining | thou)}} remaining
        </span>
    </div>
</div>
<div class="row" *ngIf="task.isComplete">
    <div class="col-sm-5">
        <label>Filtering</label>
        <p *ngIf="task.unanswered > 0">
            {{task.viable | thou}}/{{task.population | thou}}
            ({{(task.viable) / task.population | percent}})
            viable
        </p>
        <p *ngIf="task.unanswered === 0">
            All records were viable.
        </p>
        <p *ngIf="task.filter">
            {{task.processed | thou}}/{{task.viable | thou}}
            ({{(task.processed / task.viable) | percent}})
            matched filter
        </p>
        <p *ngIf="!task.filter">
            No filter; used all {{task.processed | thou}} entries
        </p>
    </div>
    <div class="col-sm-3">
        <label>Timing</label>
        <p>{{task.serverStart | date:"h:mm:ss a"}} started</p>
        <p>{{task.serverEnd | date:"h:mm:ss a"}} finished</p>
    </div>
    <div class="col-sm-4">
        <label>Duration</label>
        <p title="The amount of time the tool was actively running. This does not include pauses or scheduling delays.">
            {{task.serverSeconds}} seconds executing
        </p>
        <p>
            {{task.localSeconds}} seconds "round-trip"
        </p>
    </div>
</div>`
})
export class TaskProgressComponent
{
    @Input()
    public task : ToolboxActivity;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/task-progress.component.ts